import { getVoiceLongSilenceDelayMs } from '@/config/env/voice'

export function createVoiceWatchdog(speak) {
  const delay = getVoiceLongSilenceDelayMs()
  let timer = null

  function stop() {
    if (timer) window.clearTimeout(timer)
    timer = null
  }

  function active(context) {
    stop()
    if (!delay) return
    timer = window.setTimeout(() => {
      speak({
        ...context,
        type: 'narration',
        lane: 'status',
        text: 'I’m still working on that.',
        segment_id: `long-silence:${context.sequence}`,
      })
    }, delay)
  }

  return { active, stop }
}
